export default __webpack_public_path__ + "static/media/Accounts.837693af.svg";